import { FC } from 'react'
import styled from 'styled-components'
import Skeleton from '@app.components/Skeleton'
import DefaultChannelLogoIcon from 'svgIcons/DefaultChannelLogo'

interface WriterInfoProps {
  logoImageUrl?: string
  name?: string
  isLoading?: boolean
  className?: string
}

const WriterInfo: FC<WriterInfoProps> = ({
  logoImageUrl,
  name,
  isLoading = false,
  className,
}) => {
  if (isLoading) {
    return (
      <StyledWrapper className={className}>
        <Skeleton className="logo" />
        <Skeleton width={80} height={20} />
      </StyledWrapper>
    )
  }

  return (
    <StyledWrapper className={className}>
      {logoImageUrl ? (
        <img src={logoImageUrl} alt="writer logo" className="logo" />
      ) : (
        <DefaultChannelLogoIcon className="logo default-logo" />
      )}
      <div className="name">{name}</div>
    </StyledWrapper>
  )
}

export default WriterInfo

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  & .logo {
    width: 44px;
    height: 44px;
    margin-right: 8px;
    border: 1px solid #ddd;
    object-fit: cover;
    border-radius: 5px;
  }

  & .default-logo {
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: #eee;
  }

  & .name {
    font-size: 18px;
    font-weight: 700;
  }
`
